import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  links = [
    { nombre: 'Inicio', url: '/' },
    {
      nombre: 'Servicios',
      url: '/servicios',
      submenu: [
        { nombre: 'Rastreo Logístico', url: '/servicios/rastreoLogistico' },
        {
          nombre: 'Desarrollo de Software',
          url: '/servicios/desarrolloSoftware',
        },
      ],
    },
    { nombre: 'Nosotros', url: '/nosotros' },
    { nombre: 'Contacto', url: '/contacto' },
  ];

  banners = [
    {
      image: 'assets/images/banner1.jpg',
      titulo: 'Que tu negocio no se detenga',
      descripcion: 'Mantén el control de tu flota en cualquier momento y lugar',
      textoBoton: 'Rastreo logístico',
      urlBoton: 'servicios/rastreoLogistico',
    },
    {
      image: 'assets/images/banner2.jpg',
      titulo: 'Conoce el camino',
      descripcion: 'Para alcanzar tus objetivos',
      textoBoton: 'Desarrollo de Software',
      urlBoton: 'servicios/desarrolloSoftware',
    },
  ];

  clientes = [
    'assets/images/logoCocaColaOn.png',
    'assets/images/logoKimberlyClarkOn.png',
    'assets/images/logoSodimacOn.png',
    'assets/images/logoTransporteEstrategicoOn.png',
  ];

  datos = [
    {
      icon: 'assets/images/01.svg',
      titulo: 'Reduce el costo de combustible y mantenimiento',
      descripcion:
        'Analiza y optimiza tus rutas, reduce el gasto de combustible y mantenimiento con reportes a tu medida.',
    },
    {
      icon: 'assets/images/02.svg',
      titulo: 'Elimina o reduce el tiempo excesivo',
      descripcion:
        'Maneja tu flota eficientemente, con nuestros productos podrás reducir tiempos muertos y costos de horas hombre.',
    },
    {
      icon: 'assets/images/03.svg',
      titulo: 'Mejora la productividad y efectividad de tu flota',
      descripcion:
        'Calcula los tiempos de viaje y las tareas terminadas en tiempo real para mejorar la productividad de tu flota.',
    },
    {
      icon: 'assets/images/04.svg',
      titulo: 'Enriquece tu servicio al cliente',
      descripcion:
        'Mejora tu servicio al cliente y brinda estimaciones acertadas de entrega o recepción de mercancía.',
    },
  ];

  servicios = [
    {
      image: 'assets/images/softwareRastreo.jpg',
      title: 'Software de rastreo',
      description: 'Lorem ipsum is simply dummie text for industries graphics.',
      url: '/servicios/rastreoLogistico',
      fragment: '',
    },

    {
      image: 'assets/images/centralAlarmas.jpg',
      title: 'Central de alarmas',
      description: 'Lorem ipsum is simply dummie text for industries graphics.',
      url: '/servicios/rastreoLogistico',
      fragment: 'centralAlarmas',
    },

    {
      image: 'assets/images/servicio247.jpg',
      title: 'Servicio 24/7',
      description: 'Lorem ipsum is simply dummie text for industries graphics.',
      url: '/servicios/rastreoLogistico',
      fragment: '',
    },
  ];

  logosAcreditados = [
    'assets/images/logo_ministerio.png',
    'assets/images/logo_sutran.png',
    'assets/images/logo_osinergmin.jpg',
  ];

  constructor() {}
}
